export const ACTIVATION_PRODUCTS_SELECTION_METHOD_UNLIMITED = 'unlimited';
export const ACTIVATION_PRODUCTS_SELECTION_METHOD_LIMIT_AMOUNT = 'limit_amount';
export const ACTIVATION_PRODUCTS_SELECTION_METHOD_PRESELECTED = 'preselected';
export const ACTIVATION_PRODUCTS_SELECTION_METHOD_WEBSITE = 'website';
export const ACTIVATION_PRODUCTS_LIMITATION_METHOD_NONE = 'none';
export const ACTIVATION_PRODUCTS_LIMITATION_METHOD_PRODUCTS = 'products';
export const ACTIVATION_PRODUCTS_LIMITATION_METHOD_CATEGORIES = 'categories';
export const ACTIVATION_PRODUCTS_LIMITATION_METHOD_SLOTS = 'slots';
export const INFLUENCER_CHOICE_VALUE = {
    value: -1,
    label: 'Allow Influencer Selection',
};
